module.exports = __webpack_public_path__ + "static/media/demo_menu.5c1cb0b4.png";